/**
 * Commonly-used constants, enums/mappings
 */

export const DEFAULT_COUNTRY_ISO_CODE = 'US';
export const DEFAULT_CURRENCY_ISO_CODE = 'USD';

export const ENV_DEV = 'dev';
export const ENV_STAGING = 'staging';
export const ENV_PRODUCTION = 'production';

export const URL_STAGING_IDENTITY = 'https://id.stg.internal.atlassian.com';
export const URL_PRODUCTION_IDENTITY = 'https://id.atlassian.com';

export const URL_STAGING_WAC_DEPRECATED =
  'https://qa-wac.internal.atlassian.com';
export const URL_STAGING_WAC = 'https://wac.stg.internal.atlassian.com';
export const URL_PRODUCTION_WAC = 'https://www.atlassian.com';

export const URL_STAGING_API_PRIVATE =
  'https://wac.stg.internal.atlassian.com/gateway/api';
export const URL_PRODUCTION_API_PRIVATE =
  'https://www.atlassian.com/gateway/api';

export const RECAPTCHA_KEY = '6Le9VxMnAAAAALKRlj8jmKwUYmFTZWcF0y4o9QeD';
export const RECAPTCHA_KEY_TEST = '6LcIg3QnAAAAAPmTkAv_ZanJY5dRDUJo-i5hr_aN';

export enum ProductKey {
  JIRA_SOFTWARE = 'jira-software.ondemand',
  BITBUCKET = 'com.atlassian.bitbucket',
  CONFLUENCE = 'confluence.ondemand',
  OPSGENIE = 'opsgenie',
  JIRA_SERVICE_DESK = 'jira-servicedesk.ondemand',
  JIRA_SERVICE_MANAGEMENT = 'jira-servicedesk.ondemand',
  JIRA_CORE = 'jira-core.ondemand',
  JIRA_WORK_MANAGEMENT = 'jira-core.ondemand',
  ACCESS = 'com.atlassian.identity-manager',
  STATUSPAGE = 'statuspage',
  CONFLUENCE_PLUGIN_QUESTIONS = 'com.atlassian.confluence.plugins.confluence-questions.ondemand',
  CONFLUENCE_TEAM_CALENDARS = 'team.calendars.confluence.ondemand',
  JIRA_ROADMAPS = 'com.radiantminds.roadmaps-jira.ondemand',
  JIRA_BONFIRE = 'bonfire.jira.ondemand',
  JIRA_REFAPP = 'refapp',
  TEAM_CENTRAL = 'townsquare',
  JIRA_PRODUCT_DISCOVERY = 'jira-product-discovery',
  COMPASS = 'compass',
  ATLAS = 'townsquare',
  FABRIC = 'atlassian-whiteboard',
  BEACON = 'beacon'
}

export enum AppKey {
  TEMPO = 'is.origo.jira.tempo-plugin',
  ZEPHYR = 'com.thed.zephyr.je',
  BIGPICTURE = 'eu.softwareplant.bigpicture'
}
